import styled from "styled-components";

interface IMainButton {
  isLoading?: any;
}
export const MainButton = styled.button<IMainButton>`
  ${(props) => `
    background-color: ${
      props.disabled
        ? props.theme.colors.accentGreen + props.theme.transparencies.p20
        : props.theme.colors.accentGreen
    };
    cursor: ${props.isLoading ? "not-allowed" : "pointer"};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  color: ${(props) => props.theme.colors.white};
  align-items: center;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  font-size: 1.7rem;
  font-weight: 700;
  justify-content: center;
  min-height: 6rem;
  width: 34.8rem;
  &:disabled,
  &[disabled] {
    cursor: not-allowed;
  }

  img {
    height: 5rem;
    width: 5rem;
  }
`;

export const Container = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  align-items: center;
  border-radius: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  max-height: 82vh;
  overflow-y: auto;
  padding: 4rem;
  scrollbar-width: none;
  width: 77.9rem;

  h1 {
    ${(props) => `
      color: ${props.theme.colors.blackTextTitle};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 0;
  }
`;

export const InvoicesContainer = styled.div`
  margin-top: 4rem;
  width: 67.1rem;
`;

export const DivInvoiceVolante = styled.div`
  display: flex;
  flex-direction: column;
  width: 25rem;
`;

export const InvoiceContainer = styled.div`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  border-radius: 8px;
  box-shadow: 0px 5px 50px rgb(231 231 234 / 62%);
  font-size: 1.4rem;
  margin-bottom: 0.8rem;
  padding: 1.5rem;
  .invoce-importer {
    align-items: flex-end;
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }
  .flex-contain-invoice {
    display: flex;
  }
  div {
    display: flex;
    justify-content: space-between;
  }

  .volante-id {
    background-color: ${(props) =>
      props.theme.colors.primaryBlue + props.theme.transparencies.p10};
    color: ${(props) => props.theme.colors.primaryBlue};
    border-radius: 8px;
    font-size: 1.4rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    padding: 0.6rem;
  }

  .invoice-id {
    ${(props) => `
      color: ${props.theme.colors.blackTextTitle};
    `}
    font-weight: 600;
    margin-bottom: 0;
  }

  .importer {
    color: ${(props) =>
      props.theme.colors.blackTextTitle + props.theme.transparencies.p58};
    font-weight: 500;
    margin-bottom: 0;
  }
`;

export const PaymentContainer = styled.div`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  font-size: 1.2rem;
  width: 67.1rem;

  .special-row {
    ${(props) => `
      background-color: ${props.theme.colors.primaryBlue};
    `}
    color: ${(props) => props.theme.colors.white};
    border-radius: 8px;
    display: flex;
    font-weight: 600;
    justify-content: space-between;
    padding: 0 1rem;

    p:nth-of-type(2) {
      ${(props) => `
        font-family: ${props.theme.fontFamilies.primaryFont};
      `}
      font-weight: 800;
    }
  }
`;

export const PayerContainer = styled.div`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  margin-top: 4rem;
  width: 67.1rem;

  h2 {
    color: ${(props) =>
      props.theme.colors.blackTextBody + props.theme.transparencies.p30};
    font-size: 1.2rem;
    font-weight: 700;
  }

  h3 {
    ${(props) => `
      color: ${props.theme.colors.blackTextTitle};
    `}
    font-size: 1.3rem;
    font-weight: 500;
  }

  .credit-info {
    margin-bottom: 4rem;
    margin-top: 3.5rem;
  }

  .percentage-container {
    display: flex;
    justify-content: flex-end;
  }

  .clickable-element {
    cursor: pointer;
  }

  .panel-credit-method-dropdown.p-dropdown-panel
    .p-dropdown-items
    .p-dropdown-item {
    background: transparent;
    border-bottom: 1px solid #30345c63;
    border-radius: 0;
    border: 0 none;
    color: #495057;
    margin: 0;
    max-width: 50rem;
    padding: 0.5rem 1rem;
    transition: box-shadow 0.2s;
  }

  .dropdown-credit-method-payment {
    border: 1px solid #ffffff !important;
    box-shadow: 0px 5px 30px rgba(231, 231, 234, 0.62) !important;
    padding: 1rem !important;
    width: 100% !important;
  }
  .dropdown-credit-method-payment:not(.p-disabled):hover {
    border-color: #ffffff !important;
  }

  .dropdown-credit-method-payment:not(.p-disabled).p-focus {
    border-color: #ffffff !important;
  }
`;

interface IPercentageBar {
  percentage?: any;
}
export const PercentageBar = styled.div<IPercentageBar>`
  ${(props) => `
    background: 
      linear-gradient(
        90deg, rgba(59,74,211,1) 0%,
        rgba(59,74,211,1) ${props.percentage}%,
        rgba(237,237,239,1) ${props.percentage}%
      );
  `}
  border-radius: 5.5px;
  height: 0.6rem;
  width: 100%;
`;

export const PaginatorModal = styled.div`
  .class-paginator-color-f {
    background: #ffffff;
    padding: 0rem;
  }
`;

interface IDivPaginatorButton {
  justifyContent?: any;
}
export const DivPaginatorButton = styled.div<IDivPaginatorButton>`
  align-items: center;
  color: red;
  display: flex;
  justify-content: ${(props) =>
    props.justifyContent ? "space-between" : "center"};
  width: 100%;
  flex-direction: column;
  @media (max-width: 750px) {
    flex-direction: column;
  }
`;

interface IOptionTemplateDiv {
  marginRight?: string;
}
export const OptionTemplateDiv = styled.div<IOptionTemplateDiv>`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
    margin-right: ${props.marginRight ? props.marginRight : "0rem"};
  `}
  align-items: center;
  color: "#000000;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
`;

interface IContentLabelCredit {
  marginLeft?: string;
}
export const ContentLabelCredit = styled.div<IContentLabelCredit>`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
    margin-left: ${props.marginLeft ? props.marginLeft : "0rem"};
  `}
  color: #000000;
  cursor: pointer;
  font-size: 1.2rem;
  font-weight: 400;
`;
